module.exports = __webpack_public_path__ + "static/media/home.be6e8aef.svg";